import { Badge } from "./ui/badge";

export default function MealCard({ meal }) {
  return (
    <div className="meal-card group rounded-2xl overflow-hidden bg-white border border-neutral-200 hover:shadow-xl transition-shadow">
      <div className="aspect-[4/3] overflow-hidden bg-neutral-100 relative">
        <img
          src={meal.image}
          alt={meal.name}
          className="meal-img w-full h-full object-cover"
          loading="lazy"
        />
        {meal.tag && (
          <Badge className="absolute top-3 left-3 bg-white/95 text-green-800 hover:bg-white rounded-full text-[10px] font-bold tracking-wider">
            {meal.tag}
          </Badge>
        )}
      </div>
      <div className="p-5">
        <h3 className="font-bold text-neutral-900 text-base leading-snug">{meal.name}</h3>
        <p className="mt-2 text-sm text-neutral-600 leading-relaxed">{meal.desc}</p>
      </div>
    </div>
  );
}
